import type { CfHeaderCookieType } from '@/middleware'
import { Cookies } from 'react-cookie'

export const cfHeaderCookieName = 'cfHeader'

export const getCfHeaderCookie = () => {
  const cookieInstance = new Cookies()

  const cookie = cookieInstance.get(cfHeaderCookieName) as
    | CfHeaderCookieType
    | undefined

  if (!cookie) {
    return {
      alpha2CountryCode: null,
      zipCode: '',
      city: '',
      latitude: '',
      longitude: '',
      region: '',
    }
  }

  return cookie
}
